<template >
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">신고포상제</h1>
      <p class="page-tit">공동 운영사 소개</p>
    </div>
    <!-- 참여 기업 리스트 -->

    <section class="section-pt">
      <h2 class="section-title">참여 기업 리스트</h2>
      <div class="notice-box">
        <p class="notice-box__tit">
          '보안 취약점 신고포상제'의 공동 운영사로 참여 중인 기업들입니다.
        </p>
        <p class="notice-box__text">
          아래 기업들은 정보보호 활동을 장려하고 정보보호 확산 등 정보보호 분야
          발전을 위해 노력하는 기업입니다.
        </p>
      </div>
      <!-- 기업 리스트 -->

      <ul class="partner__list">
        <li
          v-for="(company, index) in items"
          :key="index"
          class="partner__item"
        >
          <span
            class="partner__badge"
            v-if="company.hasBadge"
            aria-hidden="true"
            ><img src="@/assets/img/img_badge.png" alt=""
          /></span>
          <img :src="company.src" :alt="company.name" class="partner__logo" />
        </li>
      </ul>
      <div class="partner__note">
        <p class="partner__note-text">
          ※ 공동운영사를 제외한 제조사에서 자체적으로 취약점 접수 채널을
          마련하여 취약점 신고를 받고 있는 경우 KISA로 신고된 취약점은 당사로
          이관되며 신고포상제 평가 및 포상대상에서는 제외됩니다.
        </p>
        <p class="partner__note-text">
          ※ 아래 기업은 독립운영사로서 자체 취약점 신고포상제를 운영하고
          있습니다. 독립운영사의 취약점은 해당 링크를 참고하시어 접수해주시기
          바랍니다.
        </p>
      </div>
      <ul class="source-card__list">
        <li>
          <a
            class="source-card"
            href="https://bugbounty.naver.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="NAVER 버그바운티 새 창에서 열림"
          >
            <span class="source-card__brand" aria-hidden="true">
              <img src="@/assets/img/company/naver.png" alt="" />
            </span>
            <span>네이버 버그바운티</span>
          </a>
        </li>
        <li>
          <a
            class="source-card"
            href="https://bugbounty.kakao.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="kakao 버그바운티 새 창에서 열림"
          >
            <span class="source-card__brand" aria-hidden="true">
              <img src="@/assets/img/company/kakao.png" alt="" />
            </span>
            <span>카카오 버그바운티</span>
          </a>
        </li>
        <li>
          <a
            class="source-card"
            href="https://www.genians.co.kr/products/bug-bounty"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="지니언스 버그바운티 새 창에서 열림"
          >
            <span class="source-card__brand" aria-hidden="true">
              <img src="@/assets/img/company/genians.png" alt="" />
            </span>
            <span>지니언스 버그바운티</span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);

    //methods 정의
    const getList = () => {
      showLoading();
      axios
        .post("/core/pu/dashboard/operation-intro/get", {})
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList;
          } else {
            items.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    // life cycle 정의
    onMounted(() => {
      getList();
    });
    // html에서 사용될 데이터 정의
    return {
      items,
    };
  },
};
</script>
